define('views/modules/calendar/personal-data/manager/personal-data-manager-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // services
    'services/i18n',
    // collections
    'collections/calendar/personal-data/personal-data-types',
    // Views
    'views/parts/list/fetch-list',
    'views/modules/calendar/personal-data/list/personal-data-list-item',
    'views/modules/calendar/personal-data/manager/edit/personal-data-edit-panel',
    'views/parts/menu/menu-action',
    // Templates Blocks
    'text!templates/modules/calendar/personal-data/manager/personal-data-manager.html'

], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // services
    i18n,
    // collections
    CPersonalDataTypes,
    // Views
    VFetchList,
    VPersonalDataListItem,
    VPersonalDataEditPanel,
    VMenuAction,
    // Template
    TPersonalDataManager
) {

    var VPersonalDataManagerContent = Backbone.View.extend({
        template: TPersonalDataManager,
        regions: {
            root: '#personal-data-manager',
            menu: ".menu-actions",
            list: "#personal-data-list",
        },

        initialize: function(options) {
            this.collection = new CPersonalDataTypes();

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-add-personal-data'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddPersonalDataAction }
                    ]),
                    tooltip: { container: this.regions.root, }
                }),

                list: new VFetchList({
                    collection: this.collection,
                    item: VPersonalDataListItem,
                    button: {
                        label: 'calendar:Show more personal datas'
                    },
                    bottom: true,
                }),
            };

            this.panel = {};

            this.listenTo(this.collection, {
                "personalData:click": this.onPersonalDataClick,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

            this.collection.getFirstPage();

            return this;
        },

        lazyInit: function() {
            var view = this.panel.edit;
            if (!view) {
                view = this.panel.edit = new VPersonalDataEditPanel({ group: this.model.get("_mainGroupId") });
                this.listenTo(view, 'form:success', this.onPersonalDataUpdate);
            }

            return view;
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onSave: function() {
            this.submit();
        },

        onPersonalDataUpdate: function(model) {
            this.collection.set(model, { remove: false });
        },

        onAddPersonalDataAction: function() {
            var panel = this.lazyInit();
            panel.resetModel();
            this.trigger('panel:stack', panel);
        },

        onPersonalDataClick: function(model) {
            if (model.get('global')) {
                Bootbox.alert({
                    title: i18n.t('you-cannot-delete-or-edit-a-global-custom-data-def-title'),
                    message: i18n.t('you-cannot-delete-or-edit-a-global-custom-data-def-content'),
                    onEscape: true,
                    backdrop: true,
                    context: this,
                });
                return;
            }
            var panel = this.lazyInit();
            panel.setModel(model);
            this.trigger('panel:stack', panel);
        },

    });

    return VPersonalDataManagerContent;
});

